var map = {
	"./hombre/pelo/barba.png": 1306,
	"./hombre/pelo/bigote.png": 1307,
	"./hombre/pelo/cabello-corto-hombre-azul.png": 1308,
	"./hombre/pelo/cabello-corto-hombre-castano.png": 1309,
	"./hombre/pelo/cabello-corto-hombre-negro.png": 1310,
	"./hombre/pelo/cabello-corto-hombre-pelirrojo.png": 1311,
	"./hombre/pelo/cabello-corto-hombre-rubio.png": 1312,
	"./hombre/pelo/cabello-corto-hombre-verde.png": 1313,
	"./hombre/pelo/cejas-hombre.png": 1314,
	"./hombre/pelo/patillas.png": 1315,
	"./hombre/pelo/pincho-hombre-azul.png": 1316,
	"./hombre/pelo/pincho-hombre-castano.png": 1317,
	"./hombre/pelo/pincho-hombre-negro.png": 1318,
	"./hombre/pelo/pincho-hombre-pelirrojo.png": 1319,
	"./hombre/pelo/pincho-hombre-rubio.png": 1320,
	"./hombre/pelo/pincho-hombre-verde.png": 1321,
	"./mujer/pelo/cabello-mujer-azul.png": 1322,
	"./mujer/pelo/cabello-mujer-castano.png": 1323,
	"./mujer/pelo/cabello-mujer-negro.png": 1324,
	"./mujer/pelo/cabello-mujer-pelirojo.png": 1325,
	"./mujer/pelo/cabello-mujer-rubio.png": 1326,
	"./mujer/pelo/cabello-mujer-verde.png": 1327,
	"./mujer/pelo/cejas-mujer.png": 1328,
	"./mujer/pelo/coleta-mujer-azul.png": 1329,
	"./mujer/pelo/coleta-mujer-castano.png": 1330,
	"./mujer/pelo/coleta-mujer-negro.png": 1331,
	"./mujer/pelo/coleta-mujer-pelirrojo.png": 1332,
	"./mujer/pelo/coleta-mujer-rubio.png": 1333,
	"./mujer/pelo/coleta-mujer-verde.png": 1334,
	"./mujer/pelo/rizado-negro.png": 1335,
	"./mujer/pelo/trenza-azul.png": 1336,
	"./mujer/pelo/trenza-castano.png": 1337,
	"./mujer/pelo/trenza-negro.png": 1338,
	"./mujer/pelo/trenza-pelirrojo.png": 1339,
	"./mujer/pelo/trenza-rubio.png": 1340,
	"./mujer/pelo/trenza-verde.png": 1341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1305;